import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import NoData from '../../../components/NoData/NoData';
import { setChart } from '../../../components/Filter/FilterActions';
import { setPageName } from './../../App/AppActions';
import { getData, getStats } from '../CFDActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';
import CFDChart from '../components/CFDChart';
import FlowStats from '../components/FlowStats';
import ArrivalDepTrendsChart from '../components/ArrivalDepChart';

import { trackTeamDashboardView, trackHowToOpened } from '../../../util/mixpanel';

import './../CFD.scss';

class CFD extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    props.dispatch(setPageName('Cumulative Flow Diagram'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('cfd');

      trackTeamDashboardView('cfd')
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.dataHash != this.props.dataHash || prevProps.hash != this.props.hash) &&
      this.props.dataIsLoading === false
    ) {
      this.handleChange();
    }

    const dataIsSame = _.isEqual(prevProps.data, this.props.data);
    if (!dataIsSame || (dataIsSame && prevProps.hash != this.props.hash)) {
      this.props.getStats(+this.props.dates.startDate, +this.props.dates.endDate, this.props.data);
    }
  }

  handleChange(force) {
    if (force || !this.props.dataIsLoading) {
      this.props.getData();
    }
  }

  trackHowToCFDOpen() {
    trackHowToOpened('cfd');
  }

  render() {
    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <p>Use the chart to:</p>
          <ul>
            <li>Analyze the flow of your work over time</li>
            <li>Reveal key insights into your process metrics</li>
            <li>Instantly spot bottlenecks</li>
          </ul>
          <a
            href={`https://getnave.com/cumulative-flow-diagram`}
            target="_blank"
            onClick={this.trackHowToCFDOpen}
            onAuxClick={this.trackHowToCFDOpen}
            className='btn btn-secondary'
          >
            Learn more
          </a>
        </div>
      </div>
    );

    const totalItems = !this.props.data ? 0 : _(this.props.data)
      .map((d) => d.data)
      .flatten()
      .map((d) => d.cards)
      .flatten()
      .uniq()
      .value().length;

    return (
      <div className="content-wrap">
        <Helmet title={`Cumulative Flow Diagram${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`} />
        <Filter totalItems={totalItems} dateformat tooltipoptions arrivaldeparturelines />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>
                Cumulative Flow Diagram
              </h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            
            <div className="button_tools">
              <Options
                showAvgChart
                showMetrics
                options={{
                  avgChartTooltip: 'Arrival & Throughput Rates chart'
                }}
              />
              <DatePicker />
            </div>
          </div>
          <div className="dashboard_details">
            {this.props.metrics && <FlowStats id="stats" data={this.props.stats} />}
            {this.props.avgChart && <ArrivalDepTrendsChart data={this.props.arrivalDepTrends} widget="adtc" />}
          </div>
          <div className="diagram_details">
            <CFDChart id="CFD" data={this.props.data} stats={this.props.stats} />
            <NoData show={!this.props.data.length} loading={this.props.isLoading} />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData()),
    getStats: (from, to, data) => dispatch(getStats(from, to, data))
  };
};

const mapStateToProps = state => {
  return {
    dates: state.filters.dates,
    hash: state.filters.cfd.hash,
    avgChart: state.filters.cfd.avgChart,
    dateFormat: state.filters.dateFormat,
    metrics: state.filters.cfd.metrics,
    data: state.cfd.data,
    stats: state.cfd.stats,
    arrivalDepTrends: state.cfd.arrivalDepTrends,
    isLoading: state.cfd.isLoading,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash,
    app: state.app.app
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CFD);
